import { Modal } from 'react-bootstrap';
import './CustomModal.css';

const CustomModal = ({
  show,
  onHide,
  children,
  header = null,
  footer = null,
  size = 'md',
  centered = true,
  loading = false,
  scrollable = false,
  showCloseButton = true,
  className = '',
  backdrop = true,
  keyboard = true,
  dialogClassName = '',
  ...props
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      dialogClassName={dialogClassName}
      centered={centered}
      scrollable={scrollable}
      backdrop={backdrop}
      keyboard={keyboard}
      className={`custom-modal ${className}`}
      enforceFocus={true}
      restoreFocus={true}
      {...props}
    >
      {/* Header */}
      {header !== null && (
        <Modal.Header
          closeButton={showCloseButton}
          className="custom-modal-header"
        >
          <Modal.Title className="custom-modal-title">
            {typeof header === 'string' ? <h5>{header}</h5> : header}
          </Modal.Title>
        </Modal.Header>
      )}

      {/* Body */}
      <Modal.Body className="custom-modal-body">
        {loading && (
          <div className="modal-loading-overlay">
            <div className="modal-spinner"></div>
          </div>
        )}
        {children}
      </Modal.Body>

      {/* Footer */}
      {footer !== null && (
        <Modal.Footer className="custom-modal-footer">{footer}</Modal.Footer>
      )}
    </Modal>
  );
};

export default CustomModal;
